import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CategoriesComponent } from './categories.component';
import { AngularMaterialModule } from 'apps/wsg/src/app/angular-material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CategoryService } from './category.service';

@NgModule({
  declarations: [
    CategoriesComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AngularMaterialModule
  ],
  exports: [
    CategoriesComponent
  ],
  providers: [
    CategoryService
  ]
})
export class CategoriesModule { }
